/**
 * Writes `value` into `ref` from an effect. React Compiler treats a ref as
 * frozen once it, or a callback reading it, is passed to a hook, so a direct
 * `ref.current = value` in that component fails `react/immutability` even in
 * an effect. Only call this after render (effects and handlers).
 */
export const assignRef = <T>(ref: { current: T }, value: T) => {
    ref.current = value;
};
